var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "w-dialog",
    {
      staticClass: "pop-dialog pop-import",
      attrs: {
        closeFree: "",
        width: "564px",
        title: _vm.dialog.title,
        top: "calc(50vh - 200px)",
      },
      on: { ok: _vm.onConfirm },
      model: {
        value: _vm.dialog.visible,
        callback: function ($$v) {
          _vm.$set(_vm.dialog, "visible", $$v)
        },
        expression: "dialog.visible",
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "import-con",
          attrs: { model: _vm.form, rules: _vm.rules, "label-width": "0" },
        },
        [
          _c("div", { staticClass: "tips" }, [_vm._v(_vm._s(_vm.dialog.info))]),
          _c(
            "el-form-item",
            { attrs: { label: "", prop: "file" } },
            [
              _c(
                "el-upload",
                {
                  ref: "tops",
                  staticClass: "upload-con",
                  attrs: {
                    accept: _vm.dialog.accept,
                    drag: "",
                    action: "#",
                    multiple: false,
                    limit: 1,
                    "before-upload": _vm.beforeUpload,
                    "on-exceed": _vm.onExceed,
                    "on-remove": _vm.onRemove,
                    "http-request": _vm.httpRequest,
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-upload" }),
                  _c("div", { staticClass: "el-upload__text" }, [
                    _vm._v(" 点击上传附件，或拖拽文件到此处 "),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }